module.exports = {
      id: "gemini-usage",
      viewBox: "0 0 48 48",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#gemini",
      toString: function () {
        return this.url;
      }
    }